import { RETURN_TO_STORAGE_KEY } from './constants';
import { LocalStorage } from './storage';

/**
 * Only same-origin paths are accepted. A stored value reaches window.location, so anything that
 * could be read as an absolute URL - including the protocol-relative "//host" form - would turn a
 * failed request into an open redirect.
 */
const isSafeInternalPath = (path: unknown): path is string =>
  typeof path === 'string' &&
  path.startsWith('/') &&
  !path.startsWith('//') &&
  !path.startsWith('/\\');

/**
 * Remembers where the user was, so login can return them there instead of the default landing
 * page. Call before redirecting to the auth route.
 */
export const setReturnTo = (path: string): void => {
  if (isSafeInternalPath(path)) {
    LocalStorage.set(RETURN_TO_STORAGE_KEY, path);
  }
};

/**
 * Reads and clears the remembered location.
 *
 * @returns the path to return to, or null if none was stored or it was not a safe internal path
 */
export const consumeReturnTo = (): string | null => {
  const stored = LocalStorage.get(RETURN_TO_STORAGE_KEY);
  LocalStorage.remove(RETURN_TO_STORAGE_KEY);

  return isSafeInternalPath(stored) ? stored : null;
};
